import { useTranslation } from "react-i18next";
import { SceneText as SceneTextType, TextLine } from "@ltypes/scene";
import DisplayForm from "@components/forms/DisplayForm/DisplayForm";
import TextField from "@components/forms/TextField/TextField";
import SceneTextLine from "./SceneTextLine/SceneTextLine";
import Button from "@components/forms/Button/Button";
import Select from "@components/forms/Select/Select";
import { FaPlus } from "react-icons/fa6";
import Product, { ProductModelType } from "@ltypes/product";
import { useSelector } from "react-redux";
import { displayModes } from "../../../constants";

type SceneTextProps = {
    scene: SceneTextType,
    onChange: (field: string, value: any) => void,
};

function SceneText(props: SceneTextProps) {

    const { t } = useTranslation();
    const product: Product = useSelector((state: any) => state.product);

    const maxLines: number = product.model.type === ProductModelType.LEGACY ? 3 : 10;

    const handleChangeLine = (index: number, line: TextLine): void => {
        const updatedLines = props.scene.lines;
        updatedLines[index] = line;
        props.onChange('lines', updatedLines);
    };

    const handleDeleteLine = (index: number): void => {
        const updatedLines = props.scene.lines;
        updatedLines.splice(index, 1);
        props.onChange('lines', updatedLines);
    };

    const handleAddLine = (): void => {
        const updatedLines = props.scene.lines;
        updatedLines[props.scene.lines.length] = {
            text: 'Hello world',
            textcolor: '#00bfff',
            speed: 50,
            textsize: product.model.type === ProductModelType.LEGACY ? 0 : 3, // small
            textalignment: 1, // center
        };
        props.onChange('lines', updatedLines);
    };

    return (
        <div className="row g-3">
            <div className="col-12">
                <div className="row g-3">
                    <div className="col-12 col-md-6">
                        <DisplayForm label={t('page.scenes.data.display_mode')} value={props.scene.display_mode} items={displayModes[product.model.type].text.map((index: number) => ({
                            id: index,
                            background: `text-${index}`,
                        }))} productModelType={product.model.type} onChange={(value: number) => props.onChange('display_mode', value)}/>
                    </div>
                    <div className="col-12 col-md-6">
                        <TextField label={t('page.scenes.data.display_duration')} value={props.scene.display_duration} onChange={(value: string) => props.onChange('display_duration', value)}/>
                    </div>
                </div>
            </div>
            {product.model.type === ProductModelType.STANDARD && (
                <div className="col-12">
                    <Select label={t('page.scenes.data.vertical_spacing')} value={props.scene.vertical_spacing} items={[
                        { label: t('text.top'), value: 0 },
                        { label: t('text.middle'), value: 1 },
                        { label: t('text.bottom'), value: 2 },
                        { label: t('text.space_between'), value: 3 },
                        { label: t('text.space_around'), value: 4 },
                    ]} onChange={(value: string) => props.onChange('vertical_spacing', Number(value))}></Select>
                </div>
            )}
            {new Array(Math.min(props.scene.lines.length, maxLines)).fill(0).map((_, index: number) => (
                <div key={index} className="col-12">
                    <SceneTextLine
                        index={index+1}
                        line={props.scene.lines.length > index ? props.scene.lines[index] : null}
                        onChange={(line: TextLine) => handleChangeLine(index, line)}
                        onDelete={() => handleDeleteLine(index)}/>
                </div>
            ))}
            <div className="col-12 text-center">
                <Button onClick={handleAddLine} disabled={props.scene.lines.length >= maxLines}><FaPlus/> {t('page.scenes.add_line')}</Button>
            </div>
        </div>
    );
}

export default SceneText;
